import { render } from "./appMain.vue?vue&type=template&id=5efe3478&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=js"
export * from "./appMain.vue?vue&type=script&lang=js"

import "./appMain.vue?vue&type=style&index=0&id=5efe3478&lang=scss&scoped=true"

import exportComponent from "/Library/WebServer/Documents/pt/qizhonghui/frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.13_vue@3.4.19_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efe3478"]])

export default __exports__